import Cart from '../components/CartDrawer.svelte'
import { dispatchCartUpdated } from '../utils/cart-updated'

let target = document.getElementById('cart-drawer')

if (!target) {
  throw new Error('cart-drawer element not found')
}

let data = {
    cart: null
};

if (target.dataset.cart) {
    data.cart = JSON.parse(target.dataset.cart)
    data.cartUrl = target.dataset.cartUrl;
    data.freeShippingThreshold = target.dataset.freeShippingThreshold;
    dispatchCartUpdated(data.cart)
}

const app = new Cart({
  target,
  props: {
    ...data
  }
})


document.querySelector('.toggle-cart')?.addEventListener('click', (e) => {
  e.preventDefault();

  document.dispatchEvent(new CustomEvent('toggle-cart'));
});

export default app
